module.exports = __webpack_public_path__ + "static/img/アセット 19@2x.5da05e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 19@2x.png
// module id = 7cyr
// module chunks = 1